import { faBullseye } from "@fortawesome/pro-regular-svg-icons"
import { faTrash } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { messageSVC } from "message/service"
import { REPORTS_EDIT_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import React from "react"
import { IUserReport } from "reports/model"
import { deleteUserReport } from "reports/tools/common"
import { FlexBox } from "ui/components/FlexBox"
import { ListActionButton } from "ui/components/main-layout/ListActionButton"

interface IMyReportsListActionsProps {
  report: IUserReport
}

export const MyReportsListActions = React.memo(({ report }: IMyReportsListActionsProps): JSX.Element => {
  const [isDeleting, setIsDeleting] = React.useState(false)
  return (
    <FlexBox
      sx={{
        gap: ".5rem",
        fontSize: "1.5rem"
      }}>
      <ListActionButton
        id={`reports-${report.id}-edit-button`}
        icon={faBullseye}
        disabled={isDeleting}
        tooltip={translate("reports.edit.title")}
        onClick={() => navigate({ path: REPORTS_EDIT_PATH, pathParams: report.id })}
      />
      <ListActionButton
        id={`reports-${report.id}-delete-button`}
        tooltip={translate("reports.delete.confirm.title")}
        disabled={isDeleting}
        isLoading={isDeleting}
        icon={faTrash}
        onClick={async () => {
          setIsDeleting(true)
          messageSVC.confirmMessage({
            icon: faTrash,
            addGenericConfirmMessage: true,
            confirmButtonLabel: translate("button.delete"),
            title: translate("reports.delete.confirm.title"),
            message: translate("reports.delete.confirm.message", report.name),
            onSuccess: async () => {
              const result = await deleteUserReport(report.id)
              if (!result) {
                setIsDeleting(false)
              }
            },
            onCancel: () => setIsDeleting(false)
          })
        }}
      />
    </FlexBox>
  )
})
